<div class="proccess-requirment-wrapper row">
    <formio-loader></formio-loader>
    <div class="{{bootstrapClass}}" *ngFor="let item of requirments">
        &nbsp;&nbsp;<input type="checkbox" id="{{item._id}}" [(ngModel)]="item.checked" (change)="notifyValue()"
            [disabled]="viewOnly">
        &nbsp;<label for="{{item._id}}" [ngClass]="{'answered-label' : viewOnly}">{{item.value}}</label>
    </div>
</div>